/* global axios */
import ApiClient from './ApiClient';

class AiMarkupAPI extends ApiClient {
  constructor() {
    super('ai_markup', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  updateConfig(config) {
    return axios.patch(this.url, { config });
  }

  test(text) {
    return axios.post(`${this.url}/test`, { text });
  }
}

export default new AiMarkupAPI();
